const GridFinderLogo = () => {
  return (
    <svg
      width="36"
      height="25"
      viewBox="0 0 36 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.285156 0.243286L18.0263 5.14363L35.7674 0.243286V20.066L18.0263 24.9821L0.285156 20.066V0.243286Z"
        fill="#0C0C0C"
      />
      <path
        d="M7.28357 9.4117V14.7705L13.946 16.6199V15.8612L8.03233 14.2014V10.376L17.6593 13.0474V21.4729L3.57031 17.5684V4.54297L17.644 8.44744V12.2729L7.28357 9.4117Z"
        fill="white"
      />
      <path
        d="M22.1062 11.2612V12.0199L32.4819 9.14297V12.9684L22.1062 15.8454V20.4454L18.4082 21.4729V8.44744L32.4819 4.54297V8.3684L22.1062 11.2612Z"
        fill="white"
      />
      <path
        d="M1.0332 19.4969L6.36624 20.9828V19.1175L2.83635 18.1374V3.57865L6.36624 4.55872V2.69343L1.0332 1.20752V19.4969Z"
        fill="#FF6100"
      />
      <path
        d="M7.11523 19.323V21.1883L18.0258 24.2075L28.9211 21.1883V19.323L18.0258 22.3422L7.11523 19.323Z"
        fill="#FF6100"
      />
      <path
        d="M7.11523 2.89893V4.76422L18.0258 7.78346L28.9211 4.76422V2.89893L18.0258 5.91817L7.11523 2.89893Z"
        fill="#FF6100"
      />
      <path
        d="M29.6543 2.69343V4.55872L33.23 3.57865V18.1374L29.6543 19.1175V20.9828L35.0332 19.4969V1.20752L29.6543 2.69343Z"
        fill="#FF6100"
      />
    </svg>
  )
}

export default GridFinderLogo
